import { render, staticRenderFns } from "./form_travel.vue?vue&type=template&id=1ec93090&scoped=true&"
import script from "./form_travel.vue?vue&type=script&lang=js&"
export * from "./form_travel.vue?vue&type=script&lang=js&"
import style0 from "./form_travel.vue?vue&type=style&index=0&id=1ec93090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec93090",
  null
  
)

export default component.exports